const BOOK = {
  SET_BOOK_QUERY: 'SET_BOOK_QUERY',
  SET_LANGUAGE_QUERY: 'SET_LANGUAGE_QUERY',
  SET_CURRENCY_QUERY: 'SET_CURRENCY_QUERY',

};

export default BOOK;
